// rfm-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
// Feature 159 (Segmentos de valor / RFM): tela /customer-rfm
// (src/resources/customerRfm/*), card do Painel 360 (LoyaltySection.tsx) e o
// link direto de seção do manual (ManualLinkButton/ManualPage/MarkdownRenderer).
// Os rótulos dos 5 grupos (Campeões, Fiéis, Promissores, Em risco, Hibernando)
// já existem em delta-03.ts/dashboards-02.ts — não duplicados aqui.
const catalogo: Record<string, string> = {
    "Segmentos de valor": "Segmentos de valor",
    "Últimos 12 meses": "Últimos 12 meses",
    "Posto principal": "Estación principal",
    "💎 Somente alto valor": "💎 Solo alto valor",
    "Antes: %{arg1}": "Antes: %{arg1}",
    "Célula R%{arg1}·F%{arg2}": "Celda R%{arg1}·F%{arg2}",
    "Limpar tudo": "Limpiar todo",
    "clientes da base · quem não abasteceu em 12 meses fica de fora": "clientes de la base · quien no cargó combustible en 12 meses queda afuera",
    "agora": "ahora",
    "há %{n} minuto": "hace %{n} minuto",
    "há %{n} minutos": "hace %{n} minutos",
    "há %{n} hora": "hace %{n} hora",
    "há %{n} horas": "hace %{n} horas",
    "há %{n} dia": "hace %{n} día",
    "há %{n} dias": "hace %{n} días",
    "Atualizado %{freshness} · últimos 12 meses": "Actualizado %{freshness} · últimos 12 meses",
    "novo": "nuevo",
    "Movimentação nos últimos 30 dias": "Movimiento en los últimos 30 días",
    "Quem subiu, quem caiu, quem chegou e quem saiu.": "Quién subió, quién bajó, quién llegó y quién se fue.",
    "▲ SUBIRAM": "▲ SUBIERON",
    "Sem movimentação de subida.": "Sin movimiento de subida.",
    "▼ CAÍRAM": "▼ BAJARON",
    "Sem movimentação de queda.": "Sin movimiento de bajada.",
    "🆕 Novos:": "🆕 Nuevos:",
    "Com filtro de posto, quem saiu da base não aparece.": "Con filtro de estación, quien salió de la base no aparece.",
    "Não abasteceram nos últimos 12 meses.": "No cargaron combustible en los últimos 12 meses.",
    "📤 Saíram (sem abastecer há mais de 12 meses):": "📤 Se fueron (sin cargar combustible hace más de 12 meses):",
    "🆕 Novo": "🆕 Nuevo",
    "O histórico mensal começa a ser guardado em %{month}. A movimentação de 30 dias acima já mostra a tendência.": "El historial mensual empieza a guardarse en %{month}. El movimiento de los últimos 30 días, arriba, ya muestra la tendencia.",
    "Clientes por grupo, mês a mês.": "Clientes por grupo, mes a mes.",
    "Buscar por nome ou CPF (3+ caracteres)": "Buscar por nombre o CPF (3+ caracteres)",
    "Abastecimentos 12m": "Cargas 12m",
    "Valor 12m": "Valor 12m",
    "Nenhum cliente neste grupo agora.": "Ningún cliente en este grupo ahora.",
    "antes: %{segment}": "antes: %{segment}",
    "Top 20% de gasto da rede": "Top 20% de gasto de la red",
    "há": "hace",
    "Mapa RFM": "Mapa RFM",
    "Recência (linhas) × frequência (colunas). Cada cor é um grupo.": "Recencia (filas) × frecuencia (columnas). Cada color es un grupo.",
    "da base": "de la base",
    "do faturamento ·": "de la facturación ·",
    "Variação nos últimos 30 dias": "Variación en los últimos 30 días",
    "Escolha um grupo acima (card, célula do mapa ou fluxo) para ver o que fazer com ele.": "Elija un grupo arriba (tarjeta, celda del mapa o flujo) para ver qué hacer con él.",
    "O grupo tem %{arg1} clientes — exportando os %{arg2} primeiros por valor.": "El grupo tiene %{arg1} clientes — exportando los primeros %{arg2} por valor.",
    "Peça a permissão de etiquetas para usar esta ação.": "Pida el permiso de etiquetas para usar esta acción.",
    "Etiquetar estes clientes": "Etiquetar estos clientes",
    "Filtre mais: posto principal, 💎 ou uma célula do mapa.": "Filtre más: estación principal, 💎 o una celda del mapa.",
    "Criar desconto para %{n}": "Crear descuento para %{n}",
    "Pontuar %{n} clientes": "Dar puntos a %{n} clientes",
    "Exportar CSV": "Exportar CSV",
    "Mais de 50.000 clientes no filtro — usando os 50.000 primeiros por valor.": "Más de 50.000 clientes en el filtro — usando los primeros 50.000 por valor.",
    "Não foi possível preparar os clientes para essa ação. Tente de novo.": "No fue posible preparar los clientes para esta acción. Intente de nuevo.",
    "Novo": "Nuevo",
    "Não foi possível exportar. Tente de novo.": "No fue posible exportar. Intente de nuevo.",
    "%{emoji} O que fazer com o grupo %{label}": "%{emoji} Qué hacer con el grupo %{label}",
    "🆕 O que fazer com os clientes novos": "🆕 Qué hacer con los clientes nuevos",
    "Chegaram (ou voltaram) nos últimos 30 dias e ainda não tinham um grupo de RFM. A 2ª visita decide se ficam.": "Llegaron (o volvieron) en los últimos 30 días y todavía no tenían un grupo de RFM. La 2ª visita decide si se quedan.",
    "Notificação de boas-vindas ou desconto na próxima visita.": "Notificación de bienvenida o descuento en la próxima visita.",
    "Use a etiqueta em Notificações, Clube de Vantagens, Sorteios, Descontos ou na Campanha de recuperação.": "Use la etiqueta en Notificaciones, Club de Beneficios, Sorteos, Descuentos o en la Campaña de recuperación.",
    "Onde usar a etiqueta?": "¿Dónde usar la etiqueta?",
    "Nova etiqueta": "Nueva etiqueta",
    "Nome da etiqueta": "Nombre de la etiqueta",
    "Etiqueta existente": "Etiqueta existente",
    "Escolha uma etiqueta": "Elija una etiqueta",
    "Etiquetar": "Etiquetar",
    "Novos": "Nuevos",
    "Não foi possível etiquetar os clientes. Tente de novo.": "No fue posible etiquetar los clientes. Intente de nuevo.",
    "Etiquetando %{total} clientes… a etiqueta \"%{tagName}\" fica completa em alguns minutos.": "Etiquetando %{total} clientes… la etiqueta \"%{tagName}\" queda completa en algunos minutos.",
    "Pronto: %{taggedNow} clientes etiquetados com \"%{tagName}\".": "Listo: %{taggedNow} clientes etiquetados con \"%{tagName}\".",
    "até %{d} dias": "hasta %{d} días",
    "%{a}–%{b} dias": "%{a}–%{b} días",
    "mais de %{d} dias": "más de %{d} días",
    "%{a}x ou mais": "%{a}x o más",
    "Veio até %{n}x nos últimos 12 meses e não abastece há mais de %{d} dias.": "Vino hasta %{n}x en los últimos 12 meses y no carga combustible hace más de %{d} días.",
    "Abasteceu nos últimos %{d} dias e veio %{n}x ou mais nos últimos 12 meses.": "Cargó combustible en los últimos %{d} días y vino %{n}x o más en los últimos 12 meses.",
    "Abasteceu nos últimos %{d} dias, mas ainda poucas vezes.": "Cargó combustible en los últimos %{d} días, pero todavía pocas veces.",
    "Veio %{n}x ou mais nos últimos 12 meses, mas não abastece há mais de %{d} dias.": "Vino %{n}x o más en los últimos 12 meses, pero no carga combustible hace más de %{d} días.",
    "Recência e frequência dos últimos 12 meses · régua fixa": "Recencia y frecuencia de los últimos 12 meses · regla fija",
    "Como funciona?": "¿Cómo funciona?",

    // Identidade — valores técnicos que o plugin de build embrulha junto com o
    // texto de tela (variante/cor do MUI em ternário, sentinela de estado, CSS
    // de layout em `sx`), mas que não são copy: manter o mesmo valor nas duas
    // línguas é o que já é feito em delta-01.ts/delta-03.ts/delta2-02.ts para
    // "flex"/"grid"/"default" etc.
    "1.15fr 0.85fr": "1.15fr 0.85fr",
    "primary": "primary",
    "filled": "filled",
    "outlined": "outlined",
    "new": "new",
    "existing": "existing",
    "%{from} → %{to}": "%{from} → %{to}",
    "%{arg1} %{arg2} · %{arg3} clientes · %{arg4}": "%{arg1} %{arg2} · %{arg3} clientes · %{arg4}",
    "%{a}–%{b}x": "%{a}–%{b}x",
    "Não conseguimos iniciar a preparação dos dados.": "No pudimos iniciar la preparación de los datos.",
    "A preparação está demorando mais que o normal.": "La preparación está tardando más de lo normal.",
    "Vezes 12m": "Veces 12m",
    "Vai etiquetar %{n} clientes com o filtro atual da tela.": "Se van a etiquetar %{n} clientes con el filtro actual de la pantalla.",
};

export default catalogo;
